/**
 * Phase 18.16-B Batch 1 — /air-freight + /luchtvracht (CMS-driven).
 */
import React from "react";
import SEO from "../components/SEO";
import QuoteForm from "../components/QuoteForm";
import ServicePageCmsWrapper from "../components/ServicePageCmsWrapper";

const AIR_FREIGHT_FALLBACK = {
  page_banner: {
    eyebrow: "Luchtvracht",
    title: "Luchtvracht met",
    highlight: "snelheid",
    subtitle: "Snellere optie voor pakketten, webshops, documenten en zakelijke spoedzendingen vanuit Nederland naar de Caribbean.",
    badges: [
      { icon: "plane", label: "Wekelijkse vluchten" },
      { icon: "package", label: "Pakketten t/m pallets" },
      { icon: "shield", label: "Verzekerd en getrackt" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Wanneer luchtvracht",
    title: "Wanneer kiest u voor luchtvracht?",
    subtitle: "Luchtvracht is afhankelijk van planning, documentcontrole, vluchtcapaciteit en inklaring. Ideaal voor urgente zendingen, documenten en kleinere pakketten.",
  },
  cta_band: {
    title: "Spoedzending op de planning?",
    description: "Antwoord binnen 1 werkdag met indicatie en planning.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons direct",
    cta_secondary_url: "tel:+31488235999",
  },
  cards: [],
};

export default function AirFreightPage() {
  return (
    <>
      <SEO
        title="Luchtvracht naar de Caribbean | 5999Cargo"
        description="Snellere luchtvracht voor pakketten, webshops, documenten en zakelijke spoedzendingen vanuit Nederland naar de Caribbean."
      />
      <ServicePageCmsWrapper
        slug="air-freight"
        fallback={AIR_FREIGHT_FALLBACK}
        testid="air-freight-page"
        bottomChildren={
          <section id="quote-section" className="relative overflow-hidden bg-[#082c50] text-white py-20 lg:py-24" data-testid="quote-section">
            <div className="absolute inset-0">
              <div className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-cyan-400/10 blur-3xl" />
              <div className="absolute -bottom-32 right-0 w-[40rem] h-[40rem] rounded-full bg-[#1a5193]/30 blur-3xl" />
            </div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
              <div>
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur-md text-[11px] uppercase tracking-[0.18em] font-chivo font-bold text-cyan-100">
                  Offerte
                </span>
                <h2 className="font-chivo font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 leading-tight">
                  Vraag direct een{" "}
                  <span className="bg-gradient-to-r from-cyan-300 via-sky-300 to-white bg-clip-text text-transparent">
                    vrijblijvende offerte aan
                  </span>
                </h2>
                <p className="mt-4 text-white/80 text-lg max-w-lg leading-relaxed">
                  Antwoord binnen 1 werkdag — inclusief totale prijs, levertijd en alle douaneformaliteiten.
                </p>
              </div>
              <div>
                <QuoteForm defaultService="air-freight" />
              </div>
            </div>
          </section>
        }
      />
    </>
  );
}
